<ng-template #actionsMenu>
  <iris-dms-show-folder-info-button [isMatMenu]="true"
                                    [folderId]="folderId()"
                                    [openFolderOnShowInfo]="openFolderOnShowInfo()">
  </iris-dms-show-folder-info-button>

  @if (!folderOrParentLocked() && hasUpdatePermission()) {
    <iris-dms-add-folder-button [isMatMenu]="true"
                                [folderId]="folderId()">
    </iris-dms-add-folder-button>
  }

  <button mat-menu-item
          data-test="dms-shareLink-menuItem-button"
          (click)="shareLink()">
    <i class="icon fa-fw fas fa-share-alt"></i>
    <span>{{ 'label.ShareLink' | translate }}</span>
  </button>

  @if (!folderOrParentLocked() && hasUpdatePermission()) {
    <mat-divider></mat-divider>
  }

  @if (hasUpdatePermission() && shouldShowEditButton()) {
    <iris-dms-edit-folder-button [isMatMenu]="true"
                                 [folderId]="folderId()">
    </iris-dms-edit-folder-button>
  }

  @if (isActionNotDisabled(folderActions.Download)) {
    <iris-dms-download-folder-button [isMatMenu]="true"
                                     [folderId]="folderId()">
    </iris-dms-download-folder-button>
  }

  <button mat-menu-item
          data-test="dms-openMoveFolderModal-menuItem-button"
          (click)="openMoveFolderModal()"
          [hidden]="isMoveBtnDisabled()">
    <i class="icon fa-fw fas fa-level-up-alt"></i>
    <span>{{ 'label.dms.MoveToFolder' | translate }}</span>
  </button>

  @if (!isCopyBtnDisabled()) {
    <iris-dms-copy-folder-button [isMatMenu]="true"
                                 [folderId]="folderId()">
    </iris-dms-copy-folder-button>
  }

  @if (hasUpdatePermission() && folderAndParentFolderAreNotLocked()) {
    <iris-dms-import-zip-folder-button [isMatMenu]="true"
                                       [folderId]="folderId()">
    </iris-dms-import-zip-folder-button>
  }

  @if (!isRemoveBtnDisabled()) {
    <mat-divider></mat-divider>
    <iris-dms-remove-folder-button id="Test-remove-folder-button"
                                   [isMatMenu]="true"
                                   [folderId]="folderId()">
    </iris-dms-remove-folder-button>
  }
  <button mat-menu-item
          data-test="folder-actions-menu_copy-folder-name"
          (click)="copyFolderName()">
    <i class="icon fa-fw fas fa-copy"></i>
    <span>{{ 'label.dms.CopyFolderName' | translate }}</span>
  </button>
  <button mat-menu-item
          data-test="folder-actions-menu_copy-folder-path"
          (click)="copyFolderPath()">
    <i class="icon fa-fw fas fa-copy"></i>
    <span>{{ 'label.dms.CopyFolderPath' | translate }}</span>
  </button>
  @if (isAdmin) {
    <mat-divider></mat-divider>
    @if (isProjectFolder()) {
      <button mat-menu-item
              (click)="fixProjectRootFolder()"
              [loadingBtn]="rootFolderFixing()"
              data-test="folder-actions-menu_fix-project-root-folder">
        <i class="icon fa-fw fas fa-tools"></i>
        <span>{{ 'label.dms.FixProjectRootFolder' | translate }}</span>
      </button>
    }
    <button mat-menu-item
            (click)="regeneratePreviews()"
            [loadingBtn]="previewRegenerating()"
            data-test="folder-actions-menu_regenerate-previews">
      <i class="icon fa-fw fas fa-sync"></i>
      <span>{{ 'label.dms.RegeneratePreviews' | translate }}</span>
    </button>
    <button mat-menu-item
            (click)="reindexElastic()"
            [loadingBtn]="elasticSearchReindexing()"
            data-test="folder-actions-menu_reindex-elastic">
      <i class="icon fa-fw fad fa-sync"></i>
      <span>{{ 'label.dms.ReindexElastic' | translate }}</span>
    </button>
  }
</ng-template>
@if (showWithTrigger()) {
  <sk-button appearance="icon"
             color="primary"
             size="sm"
             [matMenuTriggerFor]="menu"
             class="folder-actions-menu-trigger"
             [class.tile-view-folder-menu-button]="isTileView()"
             data-test="dms-folder-actions-menu-trigger"
             clickStopPropagation
             (menuOpened)="onMenuOpened()"
             (menuClosed)="onMenuClosed()"
             [ngClass]="cssClass()">
    <i class="icon far fa-ellipsis-v" [class.text-rich]="isTileView()"></i>
  </sk-button>

  <mat-menu #menu="matMenu"
            xPosition="before"
            class="iris-module-menu"
            hasBackdrop="false">
    <ng-container [ngTemplateOutlet]="actionsMenu"></ng-container>
  </mat-menu>
} @else {
  <ng-template [ngTemplateOutlet]="actionsMenu"></ng-template>
}
